// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1047) return "static/chunks/1047.68838b0800d6ab2b.js";
	if (chunkId === 661) return "static/chunks/661.664641566d39c79b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2025":"83714e9ee8e20615","2504":"ba8927558ed0546d","3997":"e6018a2b9f27d361","5416":"094bc9efba966821","6066":"f87f86498dbdb19a","6783":"25c11db81ff5c12c","8972":"ec40af1c7983c317"}[chunkId] + ".js";
};